module.exports = __webpack_public_path__ + "resources/icon-44-cancel-ban.a399ef8cb48407ac.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/manage-dialog/img/icon-44-cancel-ban.png
// module id = 627
// module chunks = 0 1 2 3